




import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "VIcon",
})
export default class VIcon extends Vue {
  @Prop({ default: false }) readonly spin?: boolean;
  @Prop({ type: Boolean, default: false }) readonly v2?: boolean;

  getIcon() {
    return this.$slots.default && this.$slots.default.length
      ? this.$slots.default[0].text?.trim()
      : null;
  }

  getSvg() {
    const dir: string = this.v2 ? "v2/" : "";

    return this.getIcon()
      ? require(`!svg-inline-loader!../assets/icons/${dir}${this.getIcon()}.svg`)
      : null;
  }
}
